/* 🤖 this file was generated by svg-to-ts */
export const iconLdo: {
  name: 'ldo';
  data: string;
} = {
  name: 'ldo',
  data: `<svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" fill="none" viewBox="0 0 32 32"><g clip-path="url(#lido__clip0_297_35)"><path fill="#F69988" d="M16 32c8.837 0 16-7.163 16-16S24.837 0 16 0 0 7.163 0 16s7.163 16 16 16"/><path fill="#fff" fill-rule="evenodd" d="m16.01 4.69 5.614 8.765-5.614 3.263-5.614-3.263zm-3.9 8.354L16 6.958l3.89 6.086L16 15.312z" clip-rule="evenodd"/><path fill="#fff" d="M16 18.648 9.493 14.86l-.174.277A7.91 7.91 0 0 0 10.396 25c3.1 3.089 8.129 3.089 11.228 0a7.91 7.91 0 0 0 1.078-9.863l-.175-.277-6.507 3.787z"/></g><defs><clipPath id="lido__clip0_297_35"><path fill="#fff" d="M0 0h32v32H0z"/></clipPath></defs></svg>`,
};
